import React from 'react';

const WorkOrdersTableNoRowsOverlay = ({
    redirectToOtherTab,
    emptySearch,
    getOtherTab,
    filterModel,
}) => {
    const quickFilterValues = filterModel.quickFilterValues || [];
    const hasQuickFilter = quickFilterValues.length > 0 && quickFilterValues[0] !== '';

    if (hasQuickFilter) {
            return (
                <div className="no-rows-overlay">
                    <p className="no-records-text">
                        No records to display. <br /> Would you like to try this search in {getOtherTab()}?
                    </p>
                    <div className="tab-panel-buttons">
                        <button id="accept-redirect" onClick={redirectToOtherTab} className="yes-button">
                            YES
                        </button>
                        <button id="decline-redirect" onClick={emptySearch} className="cancel-button">
                            CANCEL
                        </button>
                    </div>
                </div>
            );
    } else {
        return <p className="no-records-text">No records to display.</p>;
    }
};

export default WorkOrdersTableNoRowsOverlay;